import React from 'react';
import './Header.scss';

export default function Header() {
  return (
    <div className="header">
      <h3>
        Digite seu CEP no campo abaixo e aperte enter quando tiver terminado.
        Depois é só se preparar para uma mágica!
      </h3>
    </div>
  );
}
